import { render, staticRenderFns } from "./CardCompassNew.vue?vue&type=template&id=0df894fb&scoped=true&"
import script from "./CardCompassNew.vue?vue&type=script&lang=ts&"
export * from "./CardCompassNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df894fb",
  null
  
)

export default component.exports